<template>
	<div class="menu-manage-root pa-0 d-flex flex-column">
		<div flat class="flex-grow-0 flex-shrink-0 d-flex flex-row mt-2 flex-wrap">
			<div class="form-item form-item-width-3 mb-1">
				<label class="form-item-label mt-1 mr-1">选择APP:</label>
				<div class="form-item-value" style="position:relative;height:100%">
					<div style="position:absolute;top:0;bottom:0;left:0;right:0;" >					
						<v-select
						v-model="selectedApp"
						:items="apps"						
						label=""
						hide-details											
						flat
						solo
						outlined
						dense						
						return-object
						item-text="caption"
						full-width						
						>
						</v-select>
					</div>
				</div>
				
			</div>
			
				<v-btn
					class="ml-2 mb-2 right-round" 
					@click="handleApplyFilter" 
					color="primary"		
					:disabled="btnLoadMenuDisabled"					
				>	
					<v-icon>mdi-file-find</v-icon>
					加载
				</v-btn>
				
				<v-btn                
				    class="ml-2 mb-2 left-round" 
				    color="info"
					:disabled="btnAddLowerDisabled"
					@click="handleAddLower" 
				>
				    <span><v-icon>mdi-file-outline</v-icon></span>      
				    增加下级
				</v-btn>
				
				<v-btn
				    class="ml-2 mb-2 right-round" 
				    color="info"
					:disabled="btnAddSameLevelDisabled"
					@click="handleAddSameLevel" 
				>
				    <span><v-icon>mdi-file-outline</v-icon></span>      
				    增加同级
				</v-btn>
				              
				<v-btn
					rounded
				    class="ml-2 mb-2" 
				    color="info"
					:disabled="btnEditDisabled"
					@click="handleEdit" 
				>
				    <span><v-icon>mdi-notebook-edit-outline</v-icon></span>                
				    编辑                
				</v-btn>
				
				<v-btn
				    rounded
				    class="ml-4 mb-2 mr-4" 
				    color="blue-grey"
					@click="handleDelete" 
					:disabled="btnDeleteDisabled"
				>
				    <span><v-icon>mdi-note-remove-outline</v-icon></span>      
				    删除
				</v-btn>
							  
			
		</div>
		<div class="flex-grow-1 flex-shrink-1" style="position:relative;">
			<div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-1">
				<v-data-table
				:headers="headers"
				dense
				fixed-header
				:items="visibleMenus"		   
				class="elevation-1 menu-table"
				disable-pagination
				hide-default-footer
				height="100%"
				width="100%"
				single-select
				show-select
				item-key="id"
				v-model="selectedMenu"
				>
					<template v-slot:item.code="{ item }">
					    <v-container>
						<v-row>
							<v-col>
								<span v-for="n in item.level-1" :key="n"> &emsp;</span>
								<v-icon v-if="canOpen(item)" v-on:click="openMenu(item)">mdi-plus-box-outline</v-icon>
								<v-icon v-else-if="canClose(item)"  v-on:click="closeMenu(item)">mdi-minus-box-outline</v-icon>
								<v-icon v-else>mdi-border-none-variant</v-icon>
								{{ item.code}}
							</v-col>					
						</v-row>
					    </v-container>
					</template>
					
					<template v-slot:item.iconCssCls="{ item }">
					    <v-container>
						<v-row>
							<v-col>
								<span v-if="((null!=item.iconCssCls)&&(item.iconCssCls.length>0))">
									<v-tooltip right>
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												color="primary"
												dark
												v-bind="attrs"
												v-on="on"
											>
												{{ item.iconCssCls}}
											</v-icon>
										</template>
										<span>{{ item.iconCssCls}}</span>
									</v-tooltip>
								</span>
							</v-col>					
						</v-row>
					    </v-container>
					</template>
					
				</v-data-table>
			</div>
		</div>

		<MenuEditDialog 
			ref="editMenuDialog"
			v-on:menuAdded="menuAdded"
			v-on:menuUpdated="menuUpdated">
		>
		</MenuEditDialog>

	</div>
	
</template> 

<script>
	import {default as AppApi} from "../../../../api/smp/sys/AppApi.js";
	import {default as MenuApi} from "../../../../api/smp/sys/MenuApi.js";
	import MenuEditDialog from './MenuEditDialog.vue';

	export default {
		name: 'Smp-Menu-Manage',
		components: {
			'MenuEditDialog':MenuEditDialog
		},

		data: () => ({
			headers:[
				
				{ text: '代号', value: 'code',sortable: false ,width:450,divider:true,class:'table-header'},
				{text: '编号',align: 'start',sortable: false,value: 'id',width:100,divider:true,class:'table-header'},
				{ text: '名称', value: 'name',sortable: false ,width:200,divider:true,class:'table-header'},	
				{ text: '标题', value: 'title',sortable: false ,width:200,divider:true,class:'table-header'},	
                { text: '类型', value: 'typeName',sortable: false ,width:100,divider:true,class:'table-header'},
                { text: '按钮模式', value: 'buttonTypeName',sortable: false ,width:100,divider:true,class:'table-header'},
				//{ text: '末级', value: 'isLeaf',sortable: false ,width:50,divider:true},
				{ text: '排序号', value: 'orderNum',sortable: false ,width:80,divider:true,class:'table-header'},
				{ text: '图标CSS', value: 'iconCssCls',sortable: false ,width:80,divider:true,class:'table-header'},
				{ text: '界面组件模块', value: 'moduleName',sortable: false ,width:200,divider:true,class:'table-header'},
				{ text: '界面组件功能', value: 'funcName',sortable: false ,width:200,divider:true,class:'table-header'},
				{ text: '界面组件/页面路径', value: 'funcPath',sortable: false ,width:200,divider:true,class:'table-header'}
				
			],
			menus:[],
			apps:[],
			visibleMenus:[],
			selectedApp:null,
			selectedMenu:[],
		}),
		methods:{
			menuAdded(aMenu){
				console.log("menu added event");
				let me = this;
				let lenPerLevel = 4;
				let menuCode= aMenu.code;
				let parentMenuCode = menuCode.substr(0,menuCode.length-1*lenPerLevel);
				
				let parentMenu = me.findMenu(me.menus,parentMenuCode);
				if(!parentMenu){
					console.log("parentMenuCode:"+parentMenuCode+", not found");
					return;
				}
				if(!parentMenu.lower)
					parentMenu.lower = [];
				parentMenu.lower.push(aMenu);
				aMenu.higher = parentMenu;
				aMenu.level = parentMenu.level+1;
				//aMenu.opened = false;	
				parentMenu.opened = true;
				me.collectVisibleMenus();
			},
			menuUpdated(aMenu){
				console.log("menu updated event");
				let me = this;
				let menu = me.findMenu(me.menus,aMenu.code);
				if(!menu){
					console.log("menuCode:"+aMenu.code+", not found");
					return;
				}
				me.copyMenu(aMenu,menu);
			},
			copyMenu(from,to){
				to.name=from.name;
				to.title=from.title;
				to.type=from.type;
				to.typeName=from.typeName;
				to.orderNum=from.orderNum;
                to.iconCssCls=from.iconCssCls;
                
                to.buttonTypeId=from.buttonTypeId;
                to.buttonTypeName=from.buttonTypeName;

				to.moduleId=from.moduleId;
				to.moduleName=from.moduleName;
				to.moduleType=from.moduleType;
				
				to.menuModuleId = from.menuModuleId;
				to.menuModuleName = from.menuModuleName;
				to.funcId = from.funcId;
				to.funcName = from.funcName;
				to.funcPath = from.funcPath;
				to.funcType = from.funcType;
				to.funcTypeName = from.funcTypeName;
				
			},
			findMenu(menus,menuCode){
				let me = this;
				let found = null;
				menus.forEach(function(menu){
					if(menu.code==menuCode){
						found = menu;
						return;
					}else if(menuCode.substr(0,menu.code.length)==menu.code){
						if(menu.lower){
							found = me.findMenu(menu.lower,menuCode);
							return;
						}
					}
				});
				return found;
			},
			handleApplyFilter(){
				this.loadMenus();
			},
			
			handleAddLower() {
				let dialog = this.$refs.editMenuDialog;
				dialog.setMode(1);
				dialog.setHigher(this.selectedMenu[0]);
				dialog.setVisible(true);
			},
			handleAddSameLevel() {
				let dialog = this.$refs.editMenuDialog;
				dialog.setMode(2);
				dialog.setSameLevel(this.selectedMenu[0]);
				dialog.setVisible(true);
			},
			handleEdit() {
				let dialog = this.$refs.editMenuDialog;
				dialog.setMode(3);
				dialog.setEdit(this.selectedMenu[0]);
				dialog.setVisible(true);
			},
			handleDelete() {
				let me = this;
				me.errMsg('错误', '暂不支持此操作');
			},
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			loadApps(){
				let me = this;
				AppApi.queryAllApp().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取APP信息失败':msg;
						throw new Error(msg);
						return;
					}					
					
					let apps = data.data.apps;
					//修改类型名
					apps.forEach(function(app){
						app.caption="[ "+app.appId+" ]-[ "+app.appCode+" ]-[ "+app.appName+" ]";
					});
					me.apps = apps;
				}).catch(function(err){
					me.errMsg('错误','获取APP信息失败:'+err.message);
				});
			},
			loadMenus(){
				let me = this;
				if(!me.selectedApp)
					return;
				MenuApi.queryByAppId(me.selectedApp.appId).then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取菜单信息失败':msg;
						throw new Error(msg);
						return;
					}
					
					let menus = data.data.menus;	
					me.localCustomMenus(menus);
					menus = me.genTree(menus);		
					
					me.levelMenus(menus,1,null);													
					me.menus = menus;
					me.collectVisibleMenus();
				}).catch(function(err){
					console.log(err.stack);
					me.errMsg('错误','获取菜单信息失败:'+err.message);
				});
			},
			localCustomMenus(menus){
				menus.forEach(function(item){
					if(item && item.leafFlag && (item.leafFlag==1))
						item.isLeaf = '是';
					else
						item.isLeaf = '否';
				});
			},
			genTree(menus){
				let lenPerLevel=4;
				let me = this;
				let result = [];
				let map = new Map();
				let orderedMenu =  menus.sort(me.compareMenu);
				
				//let orderedMenu = menus;
				orderedMenu.forEach(function(item){
					let code = item.code;
					item.lower = [];
					if(code.length==1*lenPerLevel)
						result.push(item);
					else{
						let parentItem = map.get(code.substr(0,code.length-1*lenPerLevel));
						if(parentItem){
							parentItem.lower.push(item);
						}
					}	
					map.set(code,item);
				});
				return result;
			},
			compareMenu(menu1,menu2){
				let res = 0;
				if(menu1.code.length<menu2.code.length)
					res = -1;
				else if(menu1.code<menu2.code)	
					res = -1;
				else 
					res = 1;
				return res;
			},
			levelMenus(menus,level,higherMenu){
				let me = this;
				
				menus.forEach(function(item){
					me.menus.push(item);
					item.higher = higherMenu;
					item.level = level;
					item.opened = false;		
					if(item.lower)
						me.levelMenus(item.lower,level+1,item);		
						
				});
			},
			canOpen(menu){
				return this.hasLower(menu)&&(!menu.opened);
			},
			canClose(menu){
				return this.hasLower(menu)&&(menu.opened);
			},
			hasLower(menu){
				return menu && menu.lower && menu.lower.length && menu.lower.length>0 ;
			},
			openMenu(menu){
				menu.opened = true;
				this.collectVisibleMenus();
			},
			closeMenu(menu){
				menu.opened = false;
				this.collectVisibleMenus();
			},
			menuVisible(menu){
				if(!menu.higher)
					return true;
				return menu.higher.opened;	
			},
			collectVisibleMenu(visible,menu){
				let me = this;
				if(me.menuVisible(menu)){
					visible.push(menu);
					if(menu.lower){
						menu.lower.forEach(function(item){
							me.collectVisibleMenu(visible,item);
						});
					}
				}
			},
			collectVisibleMenus(){
				let visible = [];
				let me = this;
				me.menus.forEach(function(item){
					me.collectVisibleMenu(visible,item);
				});
				
				me.visibleMenus=visible;
			},
			
		},
		computed: {
			btnLoadMenuDisabled() {
				return !this.selectedApp;
			},
			btnAddLowerDisabled() {
				return !this.selectedMenu ||
					((this.selectedMenu instanceof Array) && (this.selectedMenu.length < 1));
			},
			btnAddSameLevelDisabled() {
				return !this.selectedMenu ||
					((this.selectedMenu instanceof Array) && (this.selectedMenu.length < 1));
			},
			btnEditDisabled() {
				return !this.selectedMenu ||
					((this.selectedMenu instanceof Array) && (this.selectedMenu.length < 1));
			},
			btnDeleteDisabled() {
				return !this.selectedMenu ||
					((this.selectedMenu instanceof Array) && (this.selectedMenu.length < 1));
			},
		},		
		created(){
			this.loadApps();
		}
	}
</script>

<style scoped>
	.menu-manage-root{
		max-width:100%;
		max-height:100%;
		width:100%;
		height:100%;
	}
	.menu-table{		
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
	.maxed{
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
	.table-header{
        /*
		background-color: lightblue !important;
        color: #1976d2 !important;
        */
	}
	.table-cell-header{
		background-color: lightblue;
	}
</style>
